import React, { useState, forwardRef } from "react";
import { useNavigate } from "react-router-dom";
import { SettingsIcon } from "src/assets/icons/settingsIcons";
import { Dropdown } from "./Dropdown.Settings";
import { useAuth } from "src/hooks/auth";
import { Key, DollarSign, Headphones, LogOut, UserPlus, Briefcase, Upload, Smartphone } from "lucide-react";

type OptionItem = {
  onSelect: () => void;
  selected: boolean;
  title: string;
  icon?: React.ReactNode;
};

export const Settings = forwardRef<HTMLDivElement, unknown>((_, ref) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [show, setShow] = useState(false);
  const href = window.location.href;

  const options: OptionItem[] = [
    {
      onSelect: () => {
        navigate("/configkeypasswordeletronic");
      },
      selected: window.location.href.includes("/configkeypasswordeletronic"),
      title: "Senha eletrônica",
      icon: <Key size={16} color="#4F46E5" />, // Ícone da senha
    },
    {
      onSelect: () => {
        navigate("/wallet/security-devices");
      },
      selected: window.location.href.includes("/tax"),
      title: "Meus Dispositivos",
      icon: <Smartphone  size={16} color="#059669" />, // Ícone de tarifa
    },
    {
      onSelect: () => {
        navigate("/tax");
      },
      selected: window.location.href.includes("/tax"),
      title: "Minhas Tarifas",
      icon: <DollarSign size={16} color="#059669" />, // Ícone de tarifa
    },
    {
      onSelect: () => {
        navigate("/support");
      },
      selected: window.location.href.includes("/support"),
      title: "Suporte",
      icon: <Headphones size={16} color="#F59E0B" />, // Ícone de suporte
    },
    {
      onSelect: () => {
        navigate("/signout");
      },
      selected: false,
      title: "Sair",
      icon: <LogOut size={16} color="#EF4444" />, // Ícone de saída
    },
  ];

  const updatedOptions: OptionItem[] = options
    .filter((item) => {
      if (user && user.role !== "MASTER") {
        return item.title !== "Get Transactions";
      } else {
        return item;
      }
    })
    .reduce((acc: OptionItem[], item: OptionItem) => {
      if (item.title === "Taxa manual" && show) {
        const newItems: OptionItem[] = [
          {
            onSelect: () => {
              navigate("/backoffice/signup-pf");
            },
            selected: href.endsWith("/backoffice/signup-pf"),
            title: "Conta PF",
            icon: <UserPlus size={16} color="#3B82F6" />, // Ícone para contas PF
          },
          {
            onSelect: () => {
              navigate("/backoffice/signup-pj");
            },
            selected: href.endsWith("/backoffice/signup-pj"),
            title: "Contas PJ",
            icon: <Briefcase size={16} color="#10B981" />, // Ícone para contas PJ
          },
          {
            onSelect: () => {
              alert("Em construção");
            },
            selected: href.endsWith("/backoffice/signup-pj"),
            title: "Cadastro em massa",
            icon: <Upload size={16} color="#F59E0B" />, // Ícone para cadastro em massa
          },
        ];
        acc.push(...newItems);
      }
      acc.push(item);
      return acc;
    }, []);

  return (
    <div ref={ref}>
      <Dropdown
        title={
          <SettingsIcon className="w-[25px] h-[25px] 1xl:w-[35px] 1xl:h-[35px] 3xl:w-[55px] 3xl:h-[55px] 6xl:w-[70px] 6xl:h-[70px]" />
        }
        min
        listWidth={200}
        width={50}
        options={updatedOptions}
      />
    </div>
  );
});
